var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":_vm.$t('loggedOutTitle')}},[_c('b-card-text',[_c('b',[_c('b-link',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t('loggedOutText')))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }